<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/add-user"
        >
          Nouveau Utilisateur
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control text-black rounded-0"
          placeholder="Search user"
          v-model="searchTerm"
          @change="filter()"
          @input="handleInput"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field == 'active'">
            <div class="switch">
              <input
                type="checkbox"
                class="switch-input"
                :id="'switch-' + props.row.id"
                :checked="props.row.active"
                @change="toggleAdActive(props.row)"
              />
              <label
                class="switch-label"
                :for="'switch-' + props.row.id"
              ></label>
            </div>
          </span>
          <span v-else-if="props.column.field == 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Voir
                  </a>
                </li> -->
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'EditUserPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'HistoryUserPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="loginAsStaff(props.row)"
                  >
                    <i
                      class="flaticon-next lh-1 me-8 position-relative top-1"
                    ></i>
                    Se connecter
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="destroyUser(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>
  <!-- <CreateNewUserModal /> -->
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
// import PaginatorContent from "@/components/PaginatorContent.vue";

export default defineComponent({
  name: "UsersList",
  components: {
    // CreateNewUserModal,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const headers = [
      {
        label: "Nom et prénom",
        field: "name",
      },
      {
        label: "Téléphone",
        field: "phone",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Date de création",
        field: "created_at",
      },

      {
        label: "Active",
        field: "active",
      },

      {
        label: "Action",
        field: "action",
      },
    ];

    const rows = ref([]);
    const filter_name = ref("");
    const date_filter = ref("");
    const filter_email = ref("");
    const dir = ref(false);
    const isLoader = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);

    const users = reactive({
      searchName: "",
      searchEmail: "",
      searchDate: "",
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    const searchQuery = ref("");
    const searchTerm = ref("");
    const isLoading = ref(false);

    const offset = ref(9);
    const DetailsColis = ref([]);
    // If you have a Form class, make sure it's imported, otherwise use a plain object or define Form
    // import Form from 'path-to-form-class';
    const form = ref({
      id: 0,
      name: "",
      email: "",
      phone: "",
      password: "",
      image: "",
    });
    const form2 = ref({
      id: 0,
      name: "",
      email: "",
      phone: "",
      password: "",
      image: "",
    });

    const picpreview = ref(null);
    const picpreview2 = ref(null);
    const storesSelected = ref([]);
    const storesList = ref([]);

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(
          `/api/auth/client/CustomerUsers?searchTerm=${users.searchTerm}&searchName=${users.searchName}&searchEmail=${users.searchEmail}&searchDate=${users.searchDate}&page=${users.current_page}&per_page=${users.per_page}`
        );

        rows.value = res.data.data.data;
        Object.assign(users, res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function filter() {
      users.searchName = filter_name.value;
      users.searchEmail = filter_email.value;
      users.searchDate = date_filter.value;
      fetchData();
    }

    function Removefilter() {
      users.searchName = '';
      users.searchEmail = '';
      users.searchDate = '';
      filter_name.value = '';
      date_filter.value = '';
      filter_email.value = '';
      fetchData();
    }

    // Debounce timer for search input
    let debounceTimer: ReturnType<typeof setTimeout> | null = null;

    function handleInput() {
      if (debounceTimer) clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
      if (!searchTerm.value || searchTerm.value === '') {
        users.searchTerm = searchTerm.value;
        filter();
      } else if (searchTerm.value && searchTerm.value.length > 2) {
        users.searchTerm = searchTerm.value;
        filter();
      }
      }, 500);
    }

    async function toggleAdActive(row) {
      Swal.fire({
        text: "Vous voulez désactiver ce compte ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, désactiver!",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/client/ActiveCustomerUser/${row.id}`, {
            active: Number(!row.active),
          });
          if (res.data.message == "success") {
            fetchData();
            showToast("Utilisateur est bien modifé", "success");
          }
        } else if (result.isDenied) {
          // const item = rows.value.find((z) => z.id === row.id);
          // if(item){
          //   item.active = row.active;
          // }
        }
      });
    }


    async function destroyUser(row) {
      Swal.fire({
      text: "Vous voulez supprimer cet utilisateur ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer!",
      }).then(async (result) => {
      if (result.isConfirmed) {
        try {
        const res = await api.post(
          `/api/auth/client/DropActiveCustomerUser/${row.id}`
        );
        if (res.data.msg === "success") {
          fetchData();
          showToast("Votre utilisateur est bien supprimé", "success");
        }
        } catch (error) {
        showToast("Échec de la suppression de l'utilisateur", "error");
        }
      }
      });
    }

    async function loginAsStaff(row) {
      try {
        const res = await api.get(`/api/auth/client/LoginAsStaff/${row.id}`);
        const d = res.data;

        if (d.msg === "unauthorized") {
          showToast("Action non autorisée", "error");
        } else if (d.msg === "inactive") {
          showToast("Cet utilisateur est désactivé", "error");
        } else if (d.msg === "no user") {
          showToast("Utilisateur introuvable", "error");
        } else if (d.msg === "no customer") {
          showToast("Client introuvable", "error");
        } else if (d.msg === "success") {
          // The token itself carries the session — no localStorage handoff,
          // so the link works even opened on a different browser/device.
          // main.ts reads ?staff_token=, sets it, and fetches the staff's
          // user/permissions from the API.
          const url = `${window.location.origin}/?staff_token=${encodeURIComponent(
            d.access_token
          )}`;

          Swal.fire({
            title: "Lien de connexion staff",
            html: `
              <p class="mb-10">Copiez ce lien et ouvrez-le dans un nouvel onglet pour vous connecter en tant que ce staff :</p>
              <input id="staff-login-link" type="text" class="swal2-input" readonly value="${url}" />
            `,
            confirmButtonText: "Copier le lien",
            showCancelButton: true,
            cancelButtonText: "Fermer",
            preConfirm: async () => {
              try {
                await navigator.clipboard.writeText(url);
              } catch (e) {
                const input = document.getElementById("staff-login-link") as HTMLInputElement | null;
                input?.select();
                document.execCommand("copy");
              }
              return true;
            },
          }).then((result) => {
            if (result.isConfirmed) {
              showToast("Lien copié dans le presse-papier", "success");
            }
          });
        } else {
          showToast("Erreur lors de la connexion", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Erreur serveur, réessayez plus tard", "error");
      }
    }

    async function openEdit(id) {
      // Logic to open edit modal or navigate to edit page
      console.log("Edit user with ID:", id);
      // For example, navigate to edit page
      window.location.href = `/edit-user/${id}`;
    }

    return {
      rows,
      headers,
      fetchData,
      getDate,
      loading,
      users,
      toggleAdActive,
      openEdit,
      destroyUser,
      loginAsStaff,
      handleInput,
      searchTerm,
      filter
    };
  },
});
</script>
